import styled from 'styled-components';

export const ContinueButton = styled.button(
  props => `
        width:100%;
        display: flex;
        height:4.5rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
        background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 130%);
        text-transform: ${props.theme.font.textTransform.upper};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        align-items: center;
        justify-content: center;
        border: none;
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? 0.3 : 1};
    `,
);

export const CommonInput = styled.input(
  props => `
    width: 100%;
    height: 4.2rem;
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    font-size: ${props.theme.font.large.font16};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    position: relative;
    cursor: pointer;
    ::placeholder {
      lin-height: ${props.theme.font.lineHeight.large};
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.grey.lightc5};
      overflow: visible;
    }
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      font-size: ${props.theme.font.large.font14};
    }
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
    text-transform: ${props.isPAN || props.isGST ? props.theme.font.textTransform.upper : ''};
`,
);

export const UserInfoForm = styled.form(
  props => `
          width:100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
      `,
);

export const HeadSubTitleTextSpan = styled.span(
  props => `
        background-color: ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.small.s8};
        display: inline-flex;
        align-self: flex-start;
        margin-bottom: 1rem;
    `,
);

export const HeadSubTitleText = styled.p(
  props => `
          font-size: ${props.theme.font.large.font14};
          color: ${props.theme.colors.black.light8};
          letter-spacing: ${props.theme.font.letterSpacing.base};
          @media only screen and (min-width:320px) and (max-width: 991px){
              font-size: ${props.theme.font.large.font14};
          }
      `,
);

export const FormWrapper = styled.div(
  props => `
          width:100%;
          display: flex;
          padding-top:${props.theme.spacing.large.l20};
      `,
);

export const InputWrapper = styled.div(
  props => `
      width:100%;
      display: flex;
      justify-content: space-between;
      align-itmes: center;
      padding-bottom:${props.theme.spacing.large.l15};
      position: relative;
      opacity: ${props.disabled ? '0.4' : '1'};
      pointer-events: ${props.disabled ? 'none' : ''};
  
      @media only screen and (min-width:320px) and (max-width: 1023px){
          padding-bottom: ${props.theme.spacing.base};
          flex-direction: column;
      }
    `,
);

export const CommonSelect = styled.select(
  props => `
    width: 100%;
    height: 4.2rem;
    background-color: ${props.theme.colors.white.base};
    display: flex;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l30} ${
    props.theme.spacing.small.s5
  } ${props.theme.spacing.base};
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    background-image: url('https://assets-gos3.goibibo.com/downarrow-1587111682.png');
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: 1.1rem auto;
    cursor: pointer;
    ::-ms-expand {
      display: none;
    }
  
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      margin-bottom: ${props.theme.spacing.base};
      font-size: ${props.theme.font.large.font14};
    }
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
`,
);

export const ErrorText = styled.span(
  props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.theme.font.small.font10};
      `,
);

export const ApiErrorText = styled.span(
  props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.theme.font.large.font14};
          padding-top: ${props.theme.spacing.base};
          text-align: ${props.theme.font.textAlign.left};
          width: 100%;
      `,
);

export const CommonLabel = styled.label(
  props => `
        font-size: 1.2rem;
        color: #000;
        font-weight: bold;
        display: flex;
        margin-bottom: 0.5rem;
    `,
);

export const CommonInputWrap = styled.div(
  props => `
          width:100%;
          display: flex;
          flex-direction: column;
          position: relative;
    `,
);

export const PopContentMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction:column;
    `,
);

export const PopContentHeadWrap = styled.div(
  props => `
        display: flex;
        padding: 2rem 0;
        flex-direction: column;
    `,
);

export const PopContentHeadText = styled.p(
  props => `
        font-size:2.8rem;
        color: #000000;
        font-weight: 900;
        @media(max-width:1023px){
            font-size:2.4rem;
        }
    `,
);

export const PopContentSubHeadText = styled.p(
  props => `
        padding-top:0.3rem;
        font-size: 1.5rem;
        color: #000;
        @media(max-width:1023px){
            font-size:1.4rem;
        }
    `,
);

export const PopContentInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `,
);

export const ButtonWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin-top:3rem;
        flex-direction: column;
    `,
);

export const SignUpStepCounterWrap = styled.div(
  props => `
        display: flex;
        background-color: #ffefdc;
        padding:0.4rem 0.6rem;
        border-radius: 0.4rem;
        margin-right: 1rem;
    `,
);

export const SignUpStepCounterWrapInner = styled.div(
  props => `
        font-size: 1rem;
        color: #e41d1d;
        text-transform: uppercase;
        span{
            font-weight: bold;
            text-transform:lowercase;
        }
    `,
);

export const PanCardUploadImageView = styled.div(
  props => `
        width:100%;
        display: flex;
        overflow:hidden;
        border: dashed 1px #6bb6f2;
        background-color: #edf7ff;
    `,
);

export const PanCardUploadPreviewWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding:2rem;
        align-items: center;
        flex-direction: column;
    `,
);

export const PanCardUploadHeadText = styled.p(
  props => `
        font-size:1.2rem;
        color: #000;
        font-weight: bold; 
    `,
);

export const PanCardUploadImgWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        height: 20rem;
        max-height:20rem;
        overflow: auto;
        margin: 1rem 0;
    `,
);

export const PanCardImgiewver = styled.div(
  props => `
        width:100%;
    `,
);

export const PanCardUploadBtnWrap = styled.div(
  props => `
        widfth:100%;
        display: flex;
        align-items: center;
    `,
);

export const UploadAgainBtn = styled.a(
  props => `
        text-decoration: none;
        font-size: 1.2rem;
        color: #0091ff;
        font-weight: 900;
        margin-right: 3rem;
        cursor: pointer;
    `,
);

export const ApproveBtn = styled.button(
  props => `
        display: flex;
        height:3.2rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
        background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 130%);
        text-transform: ${props.theme.font.textTransform.upper};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.black};
        align-items: center;
        justify-content: center;
        border: none;
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? 0.3 : 1};
        padding: 0 1rem;
    `,
);
